import { Controller } from "@hotwired/stimulus"
import { api, apiErrorMessage } from "../composables/useApi"

const SHARING_LABELS = {
  open: "Open",
  selective: "Selective",
  private_sharing: "Private"
}

const SHARING_META = {
  open: "most social",
  selective: "",
  private_sharing: "most private"
}

export default class extends Controller {
  static targets = ["options", "status", "summaryLabel"]
  static values = { userId: Number, sharingDefault: String }

  async updateDefault(event) {
    const value = event.target.value
    const previous = this.sharingDefaultValue
    this.#applySelection(value)
    this.statusTarget.textContent = "Saving..."
    this.statusTarget.classList.remove("is-error")

    try {
      await api.patch("/privacy_settings", { sharing_default: value })
      this.sharingDefaultValue = value
      this.statusTarget.textContent = "Saved"
      setTimeout(() => { this.statusTarget.textContent = "" }, 2000)
    } catch (e) {
      this.#applySelection(previous)
      this.statusTarget.textContent = apiErrorMessage(e, "Error saving")
      this.statusTarget.classList.add("is-error")
    }
  }

  #applySelection(value) {
    if (this.hasSummaryLabelTarget && SHARING_LABELS[value]) {
      this.summaryLabelTarget.textContent = SHARING_LABELS[value]
    }
    if (!this.hasOptionsTarget) return
    const radios = this.optionsTarget.querySelectorAll(".settings-radio")
    radios.forEach(radio => {
      const isMatch = radio.dataset.value === value
      radio.classList.toggle("is-checked", isMatch)
      const input = radio.querySelector('input[type="radio"]')
      if (input) input.checked = isMatch
      const meta = radio.querySelector(".settings-radio__meta")
      if (meta) {
        const fallback = SHARING_META[radio.dataset.value] || ""
        meta.innerHTML = isMatch
          ? '<i class="fas fa-check"></i>current'
          : fallback
      }
    })
  }
}
